<template>
  <div class="form-div mb-10">
    <v-card class="col-lg-8 col-xl-6 col-md-6">
      <v-form ref="form" v-model.trim="valid">
        <h2 class="blue-text justify-center text-center mb-5">
          Tell us about you.
        </h2>
        <v-row>
          <v-col md="12" sm="12" cols="12">
            <label for="" class="tiny-font">First Name</label>
            <v-text-field
              solo
              :disabled="disabled"
              :rules="nameRules"
              type="text"
              v-model.trim="fname"
              required
            ></v-text-field>
          </v-col>
          <v-col md="12" sm="12" cols="12">
            <label for="" class="tiny-font">Last Name</label>
            <v-text-field
              solo
              :disabled="disabled"
              type="text"
              :rules="lastNameRules"
              v-model.trim="lname"
              required
            ></v-text-field>
          </v-col>
          <v-col md="12" sm="12" cols="12">
            <label
              for=""
              v-if="$route.path.includes('member')"
              class="tiny-font"
              >Email</label
            >
            <label for="" v-else class="tiny-font">Company Email</label>
            <v-text-field
              solo
              :disabled="disabled"
              :rules="emailRules"
              type="email"
              v-model.trim="email"
              required
            ></v-text-field>
          </v-col>

          <v-col md="12" sm="12" cols="12" v-if="$route.path == '/member'">
            <label for="" class="tiny-font">Zip</label>
            <v-text-field
              solo
              :disabled="disabled"
              type="number"
              v-model.trim="zip"
              required
            ></v-text-field>
          </v-col>
          <v-col
            md="12"
            sm="12"
            cols="12"
            v-if="false"
          >
            <label for="" class="tiny-font">Tax Id</label>
            <v-text-field
              solo
              type="text"
              @keyup="showSlash($event)"
              v-model.trim="taxId"
              required
              placeholder="00-0000000"
              :rules="taxIdRules"
              counter="10"
              maxlength="10"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-col class="d-flex">
          <input
            class="check mt-2"
            v-model.trim="checkbox"
            type="checkbox"
            :disabled="disabled"
          />
          <v-btn
            depressed
            class="select-btn mt-1 ml-4 col-md-11"
            @click="submit"
          >
            Confirm Email & Create Account
          </v-btn>
        </v-col>
        
        <v-col v-if="error.length > 0" class="mt-3 mb-3 col-md-12">
          <v-alert dense outlined type="error">
            {{ error }}
          </v-alert>
        </v-col>
        <div class="mt-4">
          <p class="text-gray font text-justify">
            By checking the box and clicking "Confirm Email & Create Account"
            you represent that: (1) you have read and agree to the
            <a> Apaly Health Platform Term of Service Agreement</a>
            ("Agreement"), (2) you have the right, authority and capacity to
            enter into the Agreement on your own behalf, and on behalf of any
            organization that you may add to the Apaly Health Platform, as
            applicable, and 3) you wish to create an account on the Apaly Health
            Platform for yourself and any organization that you may add to the
            Apaly Health Platform.
          </p>
        </div>
      </v-form>
    </v-card>
    <div class="text-center">
      <v-dialog v-model.trim="dialog" width="800" class="success-modal">
        <v-card class="">
          <v-card-text
            class="success-modal"
            style="display:flex; flex-direction:column; justify content: center; align-items:center"
          >
            <div class="text-center">
              <svg
                width="207"
                height="186"
                viewBox="0 0 207 186"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M206.675 66.328C206.159 55.1613 205.126 44.078 204.092 32.9947C203.996 27.6147 203.362 22.2563 202.198 16.9947C201.459 14.3097 200.038 11.8461 198.065 9.82801C196.784 8.60258 195.261 7.63903 193.587 6.99468C190.516 5.90063 187.345 5.09144 184.116 4.57801C179.542 3.57872 174.913 2.82755 170.253 2.32802C163.364 1.49468 156.476 1.07802 149.501 0.744682C135.208 -0.0886509 121.258 -0.171984 107.223 0.244682C82.9414 0.911349 84.4913 1.49468 25.2504 5.74468C19.223 6.24468 14.9177 6.66135 14.315 6.82801C12.2418 7.47135 10.3134 8.48933 8.63202 9.82801C7.12675 11.2054 5.8231 12.7755 4.75726 14.4947C2.76127 18.2425 1.47796 22.3072 0.968603 26.4947C0.227467 32.3829 -0.0890207 38.3139 0.0214383 44.2447C0.0214383 53.4113 0.0214383 62.6613 0.0214383 71.9113C0.624179 85.578 1.65745 99.328 2.3463 112.995C2.0546 120.914 2.22708 128.844 2.86293 136.745C3.46364 140.592 4.80733 144.295 6.8238 147.661C7.90132 149.28 9.42139 150.578 11.2152 151.411C14.2115 152.592 17.3765 153.322 20.6007 153.578C24.8199 154.078 29.2113 154.411 33.3444 154.578C39.6301 154.578 46.0019 154.578 52.2016 154.995C63.2231 154.995 74.1586 154.995 85.0079 154.995L83.7163 159.828C83.2858 162.245 82.683 164.661 82.4247 167.078C82.2094 170.881 82.2094 174.692 82.4247 178.495C73.1253 179.411 68.9061 178.495 70.1116 182.328C70.292 182.847 70.6239 183.304 71.067 183.644C71.5102 183.984 72.0456 184.193 72.6087 184.245H76.0529C80.5304 184.661 88.7966 185.578 98.1821 185.911H107.74C110.926 185.911 114.112 185.911 117.211 185.495C126.511 184.911 134.433 183.911 139.255 183.495H142.527C143.297 183.428 144.022 183.112 144.584 182.598C145.146 182.084 145.513 181.402 145.626 180.661C145.626 177.078 141.321 177.828 139.082 177.745H130.472C130.685 174.415 130.685 171.075 130.472 167.745C130.39 166.181 130.218 164.623 129.955 163.078C129.804 161.425 129.545 159.783 129.18 158.161C128.577 156.411 127.802 154.828 127.114 153.328L159.748 151.661C165.861 151.661 176.969 152.078 185.579 150.828C190.11 150.372 194.427 148.73 198.065 146.078C200.66 143.86 202.543 140.968 203.49 137.745C204.592 133.719 205.171 129.576 205.212 125.411L206.675 88.828C206.675 81.328 206.675 73.828 206.675 66.328ZM7.34043 27.4947C7.75299 24.0629 8.80314 20.7316 10.4402 17.6613C11.0963 16.4389 11.9709 15.3386 13.0234 14.4113C14.0049 13.5279 15.1423 12.8223 16.3815 12.328C36.7886 10.578 73.8141 6.91135 107.395 6.41135C121.172 6.41135 134.949 6.41135 148.64 7.49468C155.442 7.91135 162.159 8.41135 168.875 9.32801C173.266 9.91135 177.486 10.6613 181.963 11.6613C184.379 12.1072 186.765 12.6915 189.11 13.4113C190.223 13.7173 191.252 14.258 192.124 14.9947C193.544 16.6918 194.439 18.7429 194.707 20.9113C195.261 25.1405 195.548 29.3984 195.568 33.6613C196.515 44.6613 197.29 55.6613 197.634 66.9947C197.634 74.2447 197.634 81.578 197.634 88.828L196.343 115.995H192.382C181.963 116.411 171.544 117.911 161.039 117.995L72.5226 116.245L29.4696 118.245C26.9351 118.312 24.4059 118.506 21.8923 118.828C19.3711 119.054 16.8683 119.444 14.4011 119.995L10.8708 120.745C10.8708 117.828 10.8708 115.078 10.8708 112.411C10.0958 98.9113 8.63202 84.828 7.85707 71.4947C7.34043 62.4113 6.9099 53.328 6.9099 44.2447C6.67128 38.6583 6.8151 33.0627 7.34043 27.4947ZM119.709 159.828C119.709 161.245 119.709 162.745 120.397 164.245C121.086 165.745 121.086 167.078 121.517 168.578C121.947 170.078 123.239 173.911 124.014 176.911H116.953C113.939 176.911 110.754 176.911 107.482 176.911C104.209 176.911 101.11 176.911 98.096 176.911C95.0823 176.911 91.5519 177.411 88.6243 177.661C89.6576 174.495 90.9492 171.411 91.8103 168.161C92.3731 165.712 92.8042 163.237 93.1019 160.745C93.1019 160.161 93.1019 157.161 93.1019 154.495H95.8572L119.709 153.495C119.45 155.578 119.536 157.745 119.709 159.828ZM194.535 134.828C194.048 136.424 193.126 137.863 191.865 138.995C188.533 140.9 184.712 141.854 180.844 141.745C172.922 142.328 164.053 141.745 158.973 141.745C137.619 142.828 116.437 143.995 95.2545 144.745C81.1331 145.245 67.0118 145.495 52.8904 145.411C46.6908 145.411 40.4912 145.411 34.2055 145.411C30.1585 145.411 26.1115 145.411 22.1506 144.661C20.5052 144.597 18.8658 144.43 17.2426 144.161C16.3815 144.161 15.4344 143.745 15.0039 143.078C13.0307 139.798 11.8805 136.116 11.6457 132.328C11.6457 130.078 11.6457 127.745 11.6457 125.411C13.1363 125.309 14.6326 125.309 16.1232 125.411C18.4481 125.411 20.7729 124.911 23.0978 124.745H30.1585L73.2114 125.411C91.0353 125.411 108.687 126.578 126.425 126.578C138.307 126.578 150.19 126.161 162.073 125.495C171.372 124.911 180.499 123.328 189.713 122.328L196.859 121.828V125.161C196.517 128.467 195.735 131.716 194.535 134.828Z"
                  fill="black"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M104.21 64.8271C98.5414 61.8117 93.1539 58.3264 88.1077 54.4105C87.859 54.1861 87.567 54.0114 87.2484 53.8963C86.9299 53.7811 86.5911 53.7278 86.2512 53.7395C85.9114 53.7511 85.5773 53.8273 85.2679 53.9639C84.9586 54.1005 84.68 54.2947 84.4482 54.5355C84.2164 54.7762 84.0359 55.0588 83.9169 55.3671C83.798 55.6754 83.7429 56.0033 83.7549 56.3322C83.7669 56.6611 83.8457 56.9844 83.9868 57.2838C84.128 57.5832 84.3286 57.8528 84.5774 58.0771C89.0217 62.4923 93.7683 66.6128 98.7849 70.4105C100.74 72.0348 103.188 72.9999 105.759 73.1605C107.888 72.4107 109.785 71.1488 111.27 69.4938C115.023 65.5459 118.477 61.3405 121.603 56.9105C124.1 53.4938 126.683 49.4938 129.266 45.3271C134.863 36.1605 140.374 25.8271 144.679 17.0771C144.918 16.7529 145.083 16.3837 145.164 15.9936C145.245 15.6035 145.24 15.2012 145.15 14.813C145.06 14.4248 144.886 14.0594 144.64 13.7404C144.394 13.4215 144.082 13.1563 143.723 12.9621C143.364 12.7678 142.967 12.6489 142.557 12.6131C142.148 12.5772 141.735 12.6253 141.346 12.754C140.957 12.8828 140.6 13.0895 140.299 13.3605C139.998 13.6315 139.76 13.9609 139.599 14.3271C133.83 23.3271 126.08 33.6605 119.45 43.1605C114.112 50.7438 109.376 57.6605 106.104 61.9938C105.421 62.9054 104.789 63.8512 104.21 64.8271Z"
                  fill="#3397FA"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M90.4326 102.994C99.7105 105.411 109.484 105.411 118.761 102.994C122.721 101.732 126.465 99.9064 129.869 97.5776C133.015 95.2969 135.901 92.699 138.48 89.8276C145.334 82.9193 149.97 74.235 151.826 64.8276C152.288 61.5212 152.061 58.1589 151.159 54.9387C150.257 51.7185 148.698 48.7056 146.574 46.0776C146.124 45.475 145.448 45.0675 144.691 44.9428C143.934 44.8181 143.157 44.9862 142.527 45.4109C142.209 45.619 141.938 45.8872 141.73 46.1993C141.523 46.5114 141.382 46.861 141.318 47.2269C141.254 47.5929 141.267 47.9677 141.356 48.3287C141.445 48.6898 141.609 49.0295 141.838 49.3276C144.935 53.5561 146.173 58.8003 145.282 63.9109C143.506 71.908 139.274 79.1988 133.141 84.8276C130.781 87.2233 128.12 89.323 125.219 91.0776C122.567 92.7918 119.665 94.112 116.609 94.9943C108.821 96.6365 100.728 96.3209 93.1019 94.0776C85.3388 92.1693 78.1253 88.579 72.0059 83.5776C68.1175 80.2714 65.1436 76.0778 63.3542 71.3773C61.5649 66.6769 61.0167 61.6184 61.7593 56.6609C62.8868 46.273 68.1343 36.7135 76.3973 29.9943C79.3424 27.6845 82.6203 25.8036 86.1273 24.411C89.5698 23.0268 93.1907 22.1017 96.8905 21.661C99.1076 21.2344 101.39 21.2344 103.607 21.661C105.915 22.2702 108.099 23.2566 110.065 24.5776C110.641 24.9371 111.337 25.0683 112.011 24.9442C112.684 24.8201 113.282 24.4501 113.681 23.911C114.044 23.3436 114.166 22.6624 114.022 22.01C113.877 21.3576 113.477 20.7846 112.906 20.411C110.56 18.7276 107.941 17.4323 105.157 16.5776C102.372 15.7468 99.4504 15.4357 96.5461 15.661C92.061 15.9362 87.6323 16.7766 83.3719 18.161C79.3564 19.6381 75.5629 21.6279 72.092 24.0776C66.8711 27.8276 62.4705 32.5426 59.145 37.9495C55.8195 43.3565 53.6351 49.3481 52.7182 55.5776C51.624 61.9563 52.1928 68.4985 54.3731 74.6105C56.5534 80.7225 60.2762 86.2109 65.2036 90.5776C72.5115 96.5439 81.1461 100.793 90.4326 102.994Z"
                  fill="#3397FA"
                />
              </svg>
            </div>
            <div><h2 class="text-center font mt-2">
              We sent an email to the address you entered, with a link to
              continue
            </h2></div>
            
            <div class="d-flex">
              <span> <h2
              :disabled="disabled"
              class="
                text-center
                select-btn
                mt-10
                mr-4
                pointer
              "
              @click="confirmEmail()"
            >
              Done
            </h2></span>
        
           </div>
           <div class="mt-3">    
            <span @click="resendEmail()"> <strong class="text-underline light-blue-text">Resend</strong> email if you haven't recieved an email yet!</span>
          </div>
            
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-overlay :absolute="absolute" :value="overlay">
      <v-btn color="select-btn lighten-2" @click="$router.push('/login')"> Please Check your Email </v-btn>
    </v-overlay>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import api from "../../../services/api";
export default {
  data() {
    return {
      absolute: true,
      opacity: 1,
      overlay: false,
      icons: ["mdi-home", "mdi-email", "mdi-calendar", "mdi-delete"],
      padless: false,
      dialog: false,
      email: "",
      fname: "",
      lname: "",
      type: "",
      zip: "",
      error: "",
      valid: false,
      checkbox: "",
      disabled: false,
      taxId: "",
      nameRules: [(v) => !!v || "First Name is required"],
      lastNameRules: [(v) => !!v || "Last Name is required"],
      taxIdRules: [
        (v) => !!v || "This field is required",
        (v) =>
          !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
          "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid",
      ],
    };
  },
  created() {
    this.$store.commit(
      "sideBarTitleAndDesc",
      "“If you set your goals ridiculously high and it’s a failure, you will fail above everyone else’s success.”"
    );
    this.$store.commit("sideBarDesc", "James Cameron");
  },
  computed: {
    ...mapGetters(["getEmailValidation"]),
  },

  methods: {
    showSlash(event) {
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
    },
    ...mapActions(["registerUser", "emailValidation"]),
    submit() {
      this.$refs.form.validate();
      if (this.checkbox) {
        if (this.valid) {
          //  let user = {
          //         email:this.email,
          //         firstName:this.fname,
          //         lastName:this.lname,
          //         type: this.$route.path.includes('thirdPartyAdmin') ? 'employerAdvisor' : this.$route.path.split('/')[2],
          //     }
          //     if( this.$route.path.includes('thirdPartyAdmin')){
          //          user.advisorType =  "TPA"
          //     }
          //     if(this.zip){
          //         user.zip = this.zip
          //     };
          //     api().post('/auth/signup', user).catch((err)=>{
          //         if(err){
          //           this.error = err.response.data.message
          //         }
          //     }).then((res)=>{
          //         if(res){
          //         this.error = '';
          //         this.dialog = true;

          //      }
          //    })
          let email = {
            email: this.email,
          };
          api()
            .post("/auth/validateEmail", email)
            .catch((err) => {
              if (err) {
                this.error = err.response.data.message;
                return;
              }
            })
            .then((res) => {
              if (res) {
                let user = {
                  email: this.email,
                  firstName: this.fname,
                  lastName: this.lname,
                  type: this.$route.path.includes("thirdPartyAdmin")
                    ? "tpa"
                    : this.$route.path.split("/")[2],
                };
                // if (this.$route.path.includes("thirdPartyAdmin")) {
                //   user.advisorType = "TPA";
                // }

                // if (
                //   this.taxId &&
                //   this.$route.path == "/register/member/create-account"
                // ) {
                //   user.taxId = this.taxId;
                // }

                api()
                  .post("/auth/signup", user)
                  .catch((err) => {
                    if (err) {
                      this.error = err.response.data.message;
                    }
                  })
                  .then((res) => {
                    if (res) {
                      this.error = "";
                      this.dialog = true;
                    }
                  });
              }
            });
        }
      } else if (!this.checkbox) {
        this.error = "Please check the box first";
      }
    },
    confirmEmail() {
      this.dialog = false;
      this.overlay = false;
      this.$router.push('/login')
    },
    resendEmail(){
      api()
                  .post("/auth/resend/email/confirmation", {email: this.email })
                  .catch((err) => {
                    if (err) {
                      this.error = err.response.data.message;
                    }
                  })
                  .then((res) => {
                    if (res) {
                      this.error = "";
                    }
                  });
      this.dialog = false;
      this.overlay = false;
    },
    goBack() {
      this.$emit("goBackFromUserType");
    },
    next() {
      this.$emit("changeUserTypeTab");
    },
    emailValidationFunction() {
      // <!-- @change="emailValidationFunction" -->
      const data = {
        email: this.email,
      };
      this.emailValidation(data).then((_) => {
        !this.getEmailValidation.data
          ? (this.emailRules = [this.getEmailValidation.message])
          : (this.emailRules = []);
      });
    },
  },
};
</script>
<style>
.success-modal {
  padding: 60px !important;
}
</style>